import { render, staticRenderFns } from "./MoAccountPage.vue?vue&type=template&id=20686b22&scoped=true&"
import script from "./MoAccountPage.vue?vue&type=script&lang=js&"
export * from "./MoAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./MoAccountPage.vue?vue&type=style&index=0&id=20686b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20686b22",
  null
  
)

export default component.exports